

















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Content from '@/components/Subnets/Content.vue'
import Subnet from '@/js/Subnet'

interface Subnets {
    [key: string]: Subnet
}

@Component({
    components: {
        Content,
    },
})
export default class SubnetTabs extends Vue {
    @Prop() subnets!: Subnets
}
